<template>
<div class="w-full md:w-2/3 lg:w-2/3 xl:w-2/3 mb-4">
    <vs-card  id="ro-bar-plot-loading"
    class="vs-con-loading__container px-2 widget-card">
    <card-header :title="$t('widget_review_oder_by_client')"></card-header>

      <vs-row>
        <vs-col>
 <review-order-stacked-column
        :chartId="'review-order-bar'"
        :height="'380'"
      >
      </review-order-stacked-column>
      <!-- @clickStackedSection="clickStackedSection" -->
        </vs-col>
      </vs-row>
     
    </vs-card>
  </div>
</template>

<script>
import ReviewOrderStackedColumn from '@/views/modules/import_export/review_order/components/ReviewOrderStackedColumn'
import reviewOrder from '@/http/requests/reviewOrder'
import client from '@/http/requests/client'
import loading from '@/mixins/Loading'
import CardHeader from './CardHeader.vue'
export default {
  components: {
    ReviewOrderStackedColumn,
    CardHeader
  },
  mixins: [loading],
  computed: {
    isLoading() {
      return this.loading.bar
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`ro-bar-plot-loading`)
      } else {
        this.closeLoading(`ro-bar-plot-loading`)
      }
    },
  },
  data() {
    return {
      clients: [],
      params: {
        client: [],
        status: ['1', '2', '4', '5', '6', '7', '8', '9', '11'],
      },
      filterBar: 'status',
      lastIconClicked: 'type',
      idsCharts: {
        status: [],
        clients: [],
        types: [],
      },
      loading: {
        bar: false,
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getClients()
      this.loadBar()
    },
    loadBar() {
      this.loading.bar = true
      reviewOrder
        .reviewBarPlot(this.filterBar, this.params)
        .then((res) => {
          let index_name = 0
          let index_code = 0
          let barInfo = res.data.items
          let arrayColors = []
          let categories = []
          let series = [
            {
              name: '',
              data: [],
            },
          ]
          let names = []
          barInfo.forEach((item, index) => {
            if (categories.indexOf(item.code) === -1) {
              categories[categories.length] = item.code
              this.idsCharts.clients[this.idsCharts.clients.length] = {
                code: item.code,
                id: item.id,
              }
            }
            if (names.indexOf(item.name) === -1) {
              names[names.length] = item.name
              index_name = names.length - 1
              arrayColors[index_name] = item.color
              series[index_name] = {
                name: item.name,
                data: [],
              }
              if (this.lastIconClicked == 'types') {
                this.idsCharts[this.lastIconClicked][index_name] = {
                  type: item.name,
                  id: item.type_id,
                }
              }
            }
            index_code = categories.indexOf(item.code)
            index_name = names.indexOf(item.name)
            series[index_name].data[index_code] = Number(item.total)
          })
          if (this.filterBar == 'types') {
            arrayColors = [
              '#257fd9',
              '#25d979',
              '#d9d925',
              '#d93d25',
              '#d025d9',
              '',
            ]
          }
          ApexCharts.exec(
            'review-order-bar',
            'updateOptions',
            {
              series: series,
              colors: arrayColors,
              xaxis: {
                categories: categories,
              },
            },
            false,
            true
          )
          this.loading.bar = false
        })
        .catch((err) => {
          this.loading.bar = false
          console.log(err)
        })
    },
    getClients() {
      client.list().then((res) => {
        this.clients = [...res.data.clients]
      })
    },
  },
}
</script>